import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { LoginForm } from "@/features/auth/components/LoginForm"
import { AuthLayout } from "@/features/auth/components/AuthLayout"

export const Route = createFileRoute("/auth/login/")({
    component: LoginPage,
})

function LoginPage() {
    const navigate = useNavigate()

    return (
        <AuthLayout>
            <LoginForm
                onRegisterClick={() => navigate({ to: "/auth/register" })}
                onForgotPasswordClick={() => navigate({ to: "/auth/reset-password" })}
                onSuccess={() => navigate({ to: "/" })}
            />
        </AuthLayout>
    )
}
